import React from "react";
import CalendarDatePicker from "ui/components/comp-507";

const ContractBudgetFilters = ({ filters, setFilters }) => {

  const handleDateRangeChange = (dateRange) => {
    setFilters({
      ...filters,
      startDate: dateRange?.from || undefined,
      endDate: dateRange?.to || undefined,
    });
  };

  const dateRange = {
    from: filters?.startDate,
    to: filters?.endDate,
  };

  return (
    <div className="w-full flex gap-2">
      <CalendarDatePicker
        date={dateRange}
        setDate={handleDateRangeChange}
        placeholder="Pick a date range"
      />
    </div>
  );
};

export default ContractBudgetFilters;
